import { Input, KeyCode } from "../lib/Input";
import { Time } from "../lib/Time";
import Vector2 from "../math/Vector2";
import { AbilityOptions } from "../type/AbilityOptions";
import { clamp01 } from "../util";
import GameManager from "./GameManager";
import Player from "./Player";

export default class Ability {

    trigger: KeyCode;
    triggerType: (key: KeyCode) => boolean;

    icon: number;
    player: Player;

    duration: number;
    durationTimer: number = 0;
    cooldown: number;
    cooldownTimer: number = 0;
    energyCost: number;
    info: string;

    get isCurentlyActive() {
        return this.durationTimer > 0;
    }

    constructor(player: Player, options: AbilityOptions) {
        this.player = player;
        this.icon = options.icon;
        this.trigger = options.trigger;
        this.duration = options.duration;
        this.cooldown = options.cooldown;
        this.energyCost = options.energyCost;
        this.info = options.info;
        this.triggerType = options.triggerType.bind(Input);
    }

    onUse() {}

    onDurationEnd() {}

    onCooldownEnd() {}

    onActiveUpdate() {}

    onUseDuringDuration() {}

    onUpdate() {}

    UseAbility() {
        if (this.isCurentlyActive) {
            this.onUseDuringDuration();
        }

        if (this.cooldownTimer > 0 || this.player.energy < this.energyCost) return;

        this.cooldownTimer = this.cooldown;
        this.player.UseUnergy(this.energyCost);
        if (this.duration > 0) this.durationTimer = this.duration;
        this.onUse();
    }

    Update() {
        if (this.isCurentlyActive) {
            this.durationTimer -= Time.deltaTime;
            this.onActiveUpdate();

            if (this.durationTimer <= 0) {
                this.durationTimer = 0;
                this.onDurationEnd();
            }
        } else if (this.cooldownTimer > 0) {
            this.cooldownTimer -= Time.deltaTime;

            if (this.cooldownTimer <= 0) {
                this.cooldownTimer = 0;
                this.onCooldownEnd();
            }
        }

        if (this.triggerType(this.trigger)) {
            this.UseAbility();
        }
    }

    onDraw() {}

    onKeydownDraw() {}

    Draw() {
        this.onDraw();

        if (Input.GetKey(this.trigger) && this.cooldownTimer === 0 && this.player.energy > this.energyCost) {
            this.onKeydownDraw();
        }

        const ctx = this.player.ctx;
        const engine = this.player.engine;
        
        let x: number;
        let keyName: string;

        switch (this.trigger) {

            case KeyCode.Digit1:
                x = -38;
                keyName = '1';
                break;
            case KeyCode.Digit2:
                x = 0;
                keyName = '2';
                break;
            case KeyCode.Digit3:
                keyName = '3';
                x = 38;
                break;
        
            default:
                x = 0;
                keyName = KeyCode[this.trigger];
                break;
        }
        const position = new Vector2(engine.center.x + x, engine.height - 64);
        ctx.fillStyle = this.isCurentlyActive ? '#ffff55' : '#55ff55';
        engine.FillRectScreenFromCenter(position, new Vector2(34, 34));
        GameManager.Singleton?.DrawAbilityIcon(this.icon, position);

        if (this.isCurentlyActive) {

            ctx.fillStyle = '#ffff55a0';
            ctx.fillRect(position.x - 16, position.y - 16, 32, 32);
            engine.drawTexts([`${Math.ceil(this.durationTimer)}`], position.sub(position.add(Vector2.one.scale(8))), {
                align: 'center',
                baseline: 'middle',
                color: 'black',
                size: 24
            });
            engine.drawTexts([`${Math.ceil(this.durationTimer)}`], position, {
                align: 'center',
                baseline: 'middle',
                color: 'white',
                size: 24
            });
        } else if (this.cooldownTimer > 0) {
            const cdT = clamp01(this.cooldownTimer/this.cooldown);

            ctx.fillStyle = '#5555ffa0';
            ctx.fillRect(position.x - 16, position.y + 15 + (1 - 32*cdT), 32, 32*cdT);

            engine.drawTexts([`${Math.ceil(this.cooldownTimer)}`], position.sub(position.add(Vector2.one.scale(8))), {
                align: 'center',
                baseline: 'middle',
                color: 'black',
                size: 24
            });
            engine.drawTexts([`${Math.ceil(this.cooldownTimer)}`], position, {
                align: 'center',
                baseline: 'middle',
                color: 'white',
                size: 24
            });
        } else if (this.energyCost > this.player.energy) {
            ctx.fillStyle = '#ff555555';
            ctx.fillRect(position.x - 16, position.y - 16, 32, 32);
        }

        engine.drawTexts([keyName], position.add(Vector2.up.scale(18)), {
            align: 'center',
            baseline: 'bottom',
            color: 'white'
        });

        engine.drawTexts([`${this.energyCost}`], position.add(Vector2.one.scale(16)), {
            align: 'right',
            baseline: 'bottom',
            color: this.player.energy >= this.energyCost ? 'white' : '#ff0000'
        });
    }

}